import React from "react";
import { Modal } from "antd";
import { Icon } from "Components";

interface DiscardCampaignModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DiscardCampaignModal: React.FC<DiscardCampaignModalProps> = ({
  visible,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={495}
      bodyStyle={{ padding: 0 }}
    >
      <div className="pm-modal-container">
        <div className="pm-modal-header">
          <div className="pm-modal-header-left">
            <span className="pm-modal-title">Discard campaign</span>
          </div>
          <button
            className="pm-modal-close-icon"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon type="campaignModalClose" />
          </button>
        </div>

        <div className="pm-modal-body">
          <p>This will permanently remove this campaign and stop any ongoing activity.</p>
          <br />
          <p>You will not be able to recover it.</p>
        </div>

        <div className="pm-modal-footer">
          <div className="pm-modal-footer-actions">
            <button className="pm-btn-plain" onClick={onClose}>
              Keep campaign
            </button>
            <button className="pm-btn-primary" onClick={onConfirm}>
              Discard campaign
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DiscardCampaignModal;